export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"name":"description","content":"Echopus crafts custom web and mobile applications tailored to your business. From strategy and design to full development, we build impactful digital experiences."},{"name":"format-detection","content":"telephone=no"},{"name":"theme-color","content":"#14141c"},{"name":"application-name","content":"Echopus"},{"name":"apple-mobile-web-app-title","content":"Echopus"}],"link":[{"rel":"icon","type":"image/svg+xml","href":"/favicon.svg"},{"rel":"icon","type":"image/png","sizes":"48x48","href":"/favicon-48x48.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/icon-192.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"preload","as":"font","type":"font/woff2","href":"/fonts/PP-Formula-SemiExtendedBold.woff2","crossorigin":""},{"rel":"preload","as":"font","type":"font/woff2","href":"/fonts/GT-Cinetype-Light.woff2","crossorigin":""},{"rel":"preload","as":"font","type":"font/woff2","href":"/fonts/GT-Cinetype-Regular.woff2","crossorigin":""},{"rel":"preload","as":"font","type":"font/woff2","href":"/fonts/GT-Cinetype-Bold.woff2","crossorigin":""}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"data-theme":"light"},"title":"Echopus","bodyAttrs":{"class":"page_wrapper relative"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const runtimeCompiler = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"trailingSlash":"append","componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true